import { Component, Input, OnInit, OnChanges } from "@angular/core";

import { InsaCronService } from "../../../../../insa-services";
import { FormGroup } from "@angular/forms";
import { ImportJobDetails } from "../../../../../insa-models";

@Component({
    selector: "edit-import-details",
    template: require("./edit-import-details.component.html")
})

export class EditImportDetailComponent implements OnInit{

    _activityID: any;

    @Input() editImportDetailForm: any;
    @Input() set importDetails(importData: any) {
        this._activityID = importData;}

    importData: ImportJobDetails = new ImportJobDetails();
        
    private imports: any = [];

    constructor(private _insaChronosService: InsaCronService){ }

    ngOnInit(){
      this._insaChronosService.getImportDetails().subscribe(data => this.imports = data);
      if(this._activityID !== undefined && this._activityID !== null){
          this._insaChronosService.getImportDetailsById(this._activityID).subscribe((p: any) => this.importData = p);
      }
    }

    // ngOnChanges() {
    //     this._insaChronosService.getImportDetails().subscribe(data => this.imports = data);
    //     if(this._activityID !== undefined && this._activityID !== null){
    //         this._insaChronosService.getImportDetailsById(this._activityID).subscribe(p => this.importData = p);
    //     }
        
    // }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/import-job-details/edit-import-details.component.ts